import { render, staticRenderFns } from "./RoyalCard.vue?vue&type=template&id=18251e26&scoped=true&"
import script from "./RoyalCard.vue?vue&type=script&lang=js&"
export * from "./RoyalCard.vue?vue&type=script&lang=js&"
import style0 from "./RoyalCard.vue?vue&type=style&index=0&id=18251e26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18251e26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCardTitle,VImg})
